(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["origin-preview-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('origin-preview')) {
  customElements.define('origin-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      const initialColour = this.querySelector('[data-preview-colour][aria-pressed="true"]');
      const initialImage = this.querySelector('.origin-preview-image');
      if (initialImage && initialColour?.dataset.colourImage) { initialImage.removeAttribute('srcset'); initialImage.src = initialColour.dataset.colourImage; }
      this.querySelector('[data-preview-open]').addEventListener('click', () => dialog.showModal());
      this.closest('article').querySelectorAll('[data-preview-for]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); dialog.showModal(); }));
      this.querySelector('[data-preview-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect=dialog.getBoundingClientRect(); if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close(); } });
      this.querySelector('[data-preview-notify]').addEventListener('click', () => dialog.close());
      this.querySelectorAll('[data-preview-colour]').forEach(button => button.addEventListener('click', () => {
        this.querySelectorAll('[data-preview-colour]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        const image = this.querySelector('.origin-preview-image');
        if (image && button.dataset.colourImage) { image.removeAttribute('srcset'); image.src = button.dataset.colourImage; }
      }));
      this.querySelectorAll('[data-preview-size]').forEach(button => button.addEventListener('click', () => this.querySelectorAll('[data-preview-size]').forEach(b => b.setAttribute('aria-pressed', String(b === button)))));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["origin-product-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const link = event.target.closest('[data-size-guide]');
  if (!link) return;
  const panel = document.getElementById(link.dataset.sizeGuide);
  if (panel) { event.preventDefault(); panel.open = true; panel.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); panel.querySelector('summary').focus({preventScroll:true}); }
});
  } catch(e) { console.error(e); }
})();

})();
